import { useState } from 'react';

const fileToDataUrl = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(String(reader.result));
		reader.onerror = () => reject(reader.error);
		reader.readAsDataURL(file);
	});

export const useSignatureUploader = () => {
	const [imageUrl, setImageUrl] = useState<string | null>(null);

	const onImageChange = async (image: File | null) => {
		if (!image) {
			setImageUrl(null);
			return;
		}
		const dataUrl = await fileToDataUrl(image);
		setImageUrl(dataUrl);
	};

	return {
		onImageChange,
		imageUrl,
	};
};
